import React from "react";
import WithAuth from "../../hoc/WithAuth";
import LookupTable from "../../components/tables/admin/LookupTable";

function LookupPage() {
  return (
    <div className="mt-[25px] px-[50px] py-[22px] rounded-xl bg-white">
      <LookupTable />
    </div>
  );
}

export default WithAuth(LookupPage);
